import PropTypes from "prop-types";
import React, { useEffect, useState } from "react"; 
import * as app from "../services/AppService";
import { RowItem } from "../models/Core/row-item";
import { InterfaceComponentsProps } from "../models/Core/componentsCore";
interface CurrencyInputProps extends RowItem, InterfaceComponentsProps {
    onChange?: (val: number) => void;
    model: string | number;
    elmKey?: string;
    currencyID?: string | number;
    onBlur?: () => void;
    containerClass?: String;
    tableClass?: string;
}
function CurrencyInput(Props: CurrencyInputProps) {
    const [model, setModel] = useState({
        elmntVal: "0",
        isfocused: false,
    });

    useEffect(() => {
        if (!model.isfocused)
            setModel((old) => ({
                ...old,
                elmntVal: old.isfocused
                    ? format(Props.model)
                    : app.roundNumber(Props.model, Props.currencyID, true),
            }));
    }, [Props.model, Props.currencyID, model.isfocused]);

    function handler(event: { target: { value: string } }) {
        const { value } = event.target
        if (Props.onChange && typeof Props.onChange == "function") {
            Props.onChange(+(value + "").replace(/,/g, ""));
        }
        let elmntVal = format(value);
        setModel((old) => ({
            ...old,
            elmntVal,
        }));
    }

    function format(value: string | number) {
        var arr = value.toString().split(".");
        return arr && arr.length > 1 && arr[1] === ""
            ? (+arr[0].replace(/,/g, "") || 0).toLocaleString("en-US") + "."
            : (+arr[0].replace(/,/g, "") || 0).toLocaleString("en-US") +
            (arr.length < 2 ? "" : "." + arr[1]);
    }

    function hanldeKeydown(evt: { keyCode: number; preventDefault: Function }) {
        if (
            ![
                96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 8, 39, 37, 46, 48,
                49, 50, 51, 52, 53, 54, 55, 56, 57, 9, 65, 190, 17, 86,
            ].includes(evt.keyCode)
        )
            evt.preventDefault();
    }

    function onBlur() {
        setModel({
            isfocused: false,
            elmntVal: app.roundNumber(model.elmntVal, Props.currencyID, false),
        });
        if (Props.onBlur && typeof Props.onBlur == "function") Props.onBlur();
    }

    const handleFocus = (event: { target: { select: Function } }) => {
        event.target.select();
        setModel((old) => ({ ...old, isfocused: true }));
    };

    let input = (
        <input
            type="text"
            id={Props.id ? Props.id : "cur" + Props.label}
            key={Props.elmKey}
            className={`form-control form-control-sm border rounded ${Props.isTable
                    ? " border-1  text-center " + Props.tableClass
                    : Props.class
                }`}
            disabled={Props.disabled}
            onChange={handler}
            onKeyDown={hanldeKeydown}
            value={model.elmntVal}
            onFocus={handleFocus}
            onBlur={onBlur}
        />
    );

    return Props.isTable ? (
        input
    ) : (
        <div className="mt-1">
            <label className={`fw-bold  ${Props.labelClass}`}>
                {app.translate(Props.label)}
            </label>
            <div className={`input-group rounded  ${Props.containerClass}`}>
                {input}
                {Props.icon && (
                    <button className="btn btn-light" type="button" disabled>
                        <i className={"text-primary-emphasis icofont-" + Props.icon} />
                    </button>
                )}
            </div>
        </div>
    );
}

CurrencyInput.defaultProps = {
    class: " ",
    labelClass: "text-primary-emphasis",
    containerClass: " ",
    disabled: false,
    elmKey: "input",
    isTable: false,
    currencyID: 1,
};
export default CurrencyInput;
